module.exports = {
  patients: 'Patients',
  couples: 'Couples',
  groups: 'Groups',
  back: 'Back',
  meeting: 'Meeting',
}
